import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ChinaTrackerDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ChinaTrackerScreen from "../../../screens/ChinaTracker/ChinaTrackerScreen";
import ChinaTrackerDetailsReport from "../../../screens/ChinaTracker/partials/ChinaTrackerDetailsReport";
import { useTranslation } from "../../../utils/useTranslation";
import ChinaShipmentScreen from "../../../screens/ChinaShipment/ChinaShipmentScreen";
import ChinaShipmentDetailsReport from "../../../screens/ChinaShipment/partials/ChinaShipmentDetailsReport";

const Drawer = createDrawerNavigator();

export default function ChinaTrackerDrawerNavigator() {
  const dimensions = useWindowDimensions();
  const { t } = useTranslation();
  console.log("inside this navigator");

  const translatedItems = drawerItemsMain.map((item: any) => {
    let translatedTitle = item.title;
    let translatedRoutes = [...item.routes];

    if (item.key === "ChinaTracker") {
      translatedTitle = t("chinaOrderTracker");
      translatedRoutes[0].title = t("chinaOrderTracker");
    } else if (item.key === "ChinaShipment") {
      translatedTitle = t("chinaShipment");
      translatedRoutes[0].title = t("chinaShipment");
    }

    return {
      ...item,
      title: translatedTitle,
      routes: translatedRoutes,
    };
  });

  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={translatedItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTracker",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerReport"
        component={ChinaTrackerScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTrackerDetailsReport",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerDetailsReport"
        component={ChinaTrackerDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaShipment",
          title: t("chinaShipment"),
        }}
        name="ChinaShipmentReport"
        component={ChinaShipmentScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaShipmentDetailsReport",
          title: t("chinaShipmentDetailsReport"),
        }}
        name="ChinaShipmentDetailsReport"
        component={ChinaShipmentDetailsReport}
      />
    </Drawer.Navigator>
  );
}
